import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

/**
 * 获取传入模块内所有 方法名称
 * @param storeModule {{namespaced: string}}
 * @param types {Object}
 * @param moduleName {string}
 * @return {{}}
 */
function formatModuleTypes (storeModule = {}, types = {}, moduleName = '') {
  const {
    namespaced
  } = storeModule

  return !namespaced
    ? types
    : Object.keys(types).reduce((result = {}, key) => {
      result[key] = `${moduleName}/${types[key]}`
      return result
    }, {})
}
export default new Vuex.Store({
  modules: {
    user
  },
  strict: debug
})
